import React from 'react'
import { Badge } from '@woorcs/design-system'

import { FormRevisionBadgeFormRevisionFragment } from './__generated__/FormRevisionBadge'

interface FormRevisionBadgeProps {
  revision: FormRevisionBadgeFormRevisionFragment
}

export const FormRevisionBadge = ({ revision }: FormRevisionBadgeProps) => {
  if (revision.status === 'DRAFT') {
    return (
      <Badge size='medium' variant='warning'>
        Draft
      </Badge>
    )
  }

  if (revision.status === 'ARCHIVED') {
    return (
      <Badge size='medium' variant='danger'>
        Archived
      </Badge>
    )
  }

  return <Badge size='medium'>Active</Badge>
}
